import React, { useState } from 'react';
import {
    AccountGridContainer,
    AccountGrid,
    AccountTitle,
    AccountDetails,
} from './ReviewSubmitBody.styled';
import { ImageBox } from './ShippingDetails.styled';
import {
    accountNumberZeroTrimmer,
    getFormattedPhoneNumber,
    getObjectFromArray,
    territoryValue,
    logErrorToConsole,
} from 'src/utils/util';
import { ImageContainer } from '../cart/productGuide/ProductGuide.styled';
import Edit from 'src/assets/images/Edit.svg';
import { sizes } from 'src/styles/Media.styled';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import { isMobileDevice } from 'src/utils/util';
import { ALLDISTRICTS } from '../common/constants';
import { ImageWrapper } from './ShippingDetails.styled';
import {
    ORDER_CONSIGNMENT_ADD_STEPS,
    COUNTRY_CODE_JAPN,
} from 'src/constants/productConstants';
import { setProgressBarCurrentStep } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ENABLED } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { getDisplayDate } from 'src/utils/dateUtils.js';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const SurgeryDetails = ({
    consignmentAddDetails,

    accountId,

    isSubmitClicked,

    procedures,
    countryCode,
    implantDate,
    isOrderDetailsPage= false,
}) => {
    const dispatch = useDispatch();
    const [expandedCard, setExpandedCard] = useState({
        itemDetails: true,
    });
    // const [territory, setTerritory] = useState('');

    //    useEffectWithErrorLogging(() => {
    //        consignmentAddDetails?.territoryId ? setTerritory(getTerritoryNameWithTag()) : setTerritory('');

    //     },[]);

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    useEffectWithErrorLogging(() => {
        if (window.innerWidth > sizes.mobileDevice || isSubmitClicked) {
            setExpandedCard({
                ...expandedCard,
                itemDetails: true,
            });
        } else if (window.innerWidth <= sizes.mobileDevice) {
            setExpandedCard({
                ...expandedCard,
                itemDetails: true,
            });
        }
    }, []);
    const { t } = useTranslation();
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    return (
        <AccountGridContainer
            container
            justifyContent={'space-between'}
            direction="row"
            isCondensedView={isCondensedView}
            isOrderDetailsPage={isOrderDetailsPage}
        >
            <AccountGrid
            id="consignmentAdd-submit-surgery-details-toggle"
                onClick={() =>
                    toggleCard('itemDetails', !expandedCard.itemDetails)
                }
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                mobile={12}
            >
                <AccountTitle>
                    {t('ConsignmentAdd.submit.surgeryDetails')}
                    <ImageBox  marginRight = {isCondensedView && !isOrderDetailsPage&& '20px'}>
                        {isSubmitClicked ? (
                            ''
                        ) : (
                            <ImageWrapper padding={isCondensedView &&'17px'}>
                                <img
                                id="consignmentAdd-submit-surgery-edit-button"
                                    src={Edit}
                                    onClick={() => {
                                        try {
                                            dispatch(
                                                setProgressBarCurrentStep(
                                                    ORDER_CONSIGNMENT_ADD_STEPS[0]
                                                )
                                            );
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                ></img>
                            </ImageWrapper>
                        )}                        
                        <ImageContainer
                            src={DownArrowFilter}
                            alt="down-arrow"
                            isExpanded={expandedCard.itemDetails}
                            style={{
                                marginLeft: isCondensedView ? '20px' : isSubmitClicked ? '15px' : '20px',
                                width: isMobileDevice() ? '' : !isOrderDetailsPage && '18px',
                                height: isMobileDevice() ? '' : !isOrderDetailsPage && '25px',
                                display: 'flex',
                                marginRight: isMobileDevice() ? (isOrderDetailsPage ? '5px' : '40px'): (!isOrderDetailsPage && '40px'),
                            }}
                        />
                    </ImageBox>
                </AccountTitle>
            </AccountGrid>
            {expandedCard.itemDetails ? (
                <>
                    {consignmentAddDetails?.procedureCode && (
                        <AccountGrid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={6}
                        >
                            {/* {procedureTypeConsignmentAdd !== 'NOT_VISIBLE' ? ( */}
                            <div style={{ marginTop: '10px' }}>
                                <AccountDetails isDemi>
                                    {t('ConsignmentAdd.submit.procedureType')}
                                </AccountDetails>

                                <AccountDetails isRegular>
                                    {
                                        getObjectFromArray(
                                            procedures,
                                            'procedureCode',
                                            consignmentAddDetails?.procedureCode
                                        )?.procedureDescription
                                    }
                                </AccountDetails>
                            </div>
                            {/* ) : null} */}
                        </AccountGrid>
                    )}
                    {implantDate ? (
                        <AccountGrid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={6}
                            xl={6}
                            mobile={6}
                        >
                            <div style={{ marginTop: '10px' }}>
                                <AccountDetails isDemi>
                                    {t(
                                        'consignmentBilling.account.implantDate'
                                    )}
                                </AccountDetails>
                                <div style={{ display: 'flex' }}>
                                    <AccountDetails isRegular>
                                        {getDisplayDate(implantDate)}
                                    </AccountDetails>
                                </div>
                            </div>
                        </AccountGrid>
                    ) : null}
                </>
            ) : null}
        </AccountGridContainer>
    );
};

export default SurgeryDetails;
